export const openOAuthPopup = (authUrl) => {
    const width = 500;
    const height = 550;
    const left = (window.screen.width - width) / 2;
    const top = (window.screen.height - height) / 2;
    const popupWindow = window.open(authUrl, 'oauthPopup', `width=${width},height=${height},top=${top},left=${left},scrollbars=yes,resizable=yes`);
    if (!popupWindow) {
        console.error('Failed to open OAuth popup - might be blocked');
    }
    return popupWindow;
};
const FLOW_TIMEOUT_MS = 5 * 60 * 1000;
const CLOSED_CHECK_INTERVAL_MS = 500;
const STATUS_POLL_INTERVAL_MS = 2000;
// Status reads after the popup closes without a completion message, giving the platform about
// 10 seconds to store the credential.
const STATUS_POLLS_AFTER_CLOSE = 5;
/**
 * Waits for the platform's V2 OAuth callback to finish in the popup. The callback page posts
 * `OAUTH_SUCCESS` or `OAUTH_ERROR` to its opener and closes itself. A provider that sets COOP
 * (Google does) cuts the popup off from its opener, so that message never arrives; when the popup
 * closes without one, `isConnected` is polled to see whether the credential landed anyway.
 */
export const waitForOAuthCompletion = (popupWindow, isConnected) => {
    return new Promise((resolve, reject) => {
        if (!popupWindow) {
            reject(new Error('Failed to open OAuth popup'));
            return;
        }
        let settled = false;
        const finish = (error) => {
            if (settled)
                return;
            settled = true;
            window.removeEventListener('message', messageHandler);
            clearInterval(checkClosed);
            clearTimeout(timeout);
            if (!popupWindow.closed) {
                popupWindow.close();
            }
            if (error) {
                reject(error);
            }
            else {
                resolve();
            }
        };
        // The callback page is served by the platform API, not the add-in, so its origin differs
        // from ours. A forged message can only trigger a refresh of the connection state, which is
        // read back from the server.
        const messageHandler = (event) => {
            if (event.data?.type === 'OAUTH_SUCCESS') {
                finish();
            }
            else if (event.data?.type === 'OAUTH_ERROR') {
                finish(new Error('OAuth authentication failed'));
            }
        };
        const pollStatusAfterClose = async () => {
            for (let attempt = 0; attempt < STATUS_POLLS_AFTER_CLOSE && !settled; attempt++) {
                try {
                    if (await isConnected()) {
                        finish();
                        return;
                    }
                }
                catch {
                    // A transient read failure should not end the flow early.
                }
                await new Promise((wait) => setTimeout(wait, STATUS_POLL_INTERVAL_MS));
            }
            finish(new Error('OAuth window closed before authentication completed'));
        };
        const checkClosed = setInterval(() => {
            if (popupWindow.closed) {
                clearInterval(checkClosed);
                void pollStatusAfterClose();
            }
        }, CLOSED_CHECK_INTERVAL_MS);
        const timeout = setTimeout(() => finish(new Error('OAuth flow timed out')), FLOW_TIMEOUT_MS);
        window.addEventListener('message', messageHandler);
    });
};
